import { Component } from '@angular/core';

@Component({
  selector: 'app-behavior-report',
  standalone: true,
  imports: [],
  templateUrl: './behavior-report.component.html',
  styleUrl: './behavior-report.component.css'
})
export class BehaviorReportComponent {

}
